import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalTypeDynamicHeightModule } from './dynamicHeight';
import { ModalTypePopupModule } from './popup';

import { ModalTypeComponent } from './modal-type.shared.component';

const toExportModules: any[] = [
    ModalTypeDynamicHeightModule,
    ModalTypePopupModule,
];

@NgModule({
    declarations: [
        ModalTypeComponent
    ],
    imports: [
        CommonModule,
        ...toExportModules,
    ],
    exports: [
        ModalTypeComponent,
        ...toExportModules,
    ],
    providers: [],
})
export class ModalsTypesModule { }
